import APIClient from '@/shared/http/clients/api'

const resourceName = 'movimentacao-diaria-conta'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=dataMovimento,contaCorrente,desc`, config)
const GetAllClassificacaoLancamento = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/getAllClassificacaoLancamento`, data, config)

/**
 * @name DailyAccountMovementRepository
 * @description Movimentação diária conta
 * @type { Respository }
 */
const DailyAccountMovementRepository = {
  Search,
  GetAllClassificacaoLancamento
}

export default DailyAccountMovementRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/dailyaccountmovement.js